import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CookiesFacade } from 'src/app/_core/state/dialogs/cookies/cookies.facade';
import { CookieConsent } from 'src/app/_core/state/dialogs/cookies/service/models/cookie-consent';

@Component({
  selector: 'opac-cookies-settings',
  templateUrl: './cookies-settings.component.html',
  styleUrls: ['./cookies-settings.component.scss']
})
export class CookiesSettingsComponent {
  private readonly cookiesFacade = inject(CookiesFacade);

  readonly requiredCookies = toSignal<CookieConsent[]>(this.cookiesFacade.requiredCookies$);
  readonly optionalCookies = toSignal<CookieConsent[]>(this.cookiesFacade.optionalCookies$);
  readonly hideText = signal<boolean>(false);

  readonly trackCookiesFn = (_: number, cookie: CookieConsent) => cookie.id;

  setCookieConsent(cookieId: string, accepted: boolean) {
    this.cookiesFacade.setCookieConsent(cookieId, accepted);
  }

}
